function classname(t) {
  return t.constructor.name
}

export default classname
